// Client\client-vite\src\pages\Transport\TransportPage.tsx

const TransportPage = () => {
  return (
    <div>TransportPage</div>
  )
}

export default TransportPage